export enum CardName {
    BUSINESS_INFORMATION = 'Business Info',
    CONTACT_INFORMATION = 'Contact',
    PAYMENTS_INFORMATION = 'Payments',
    COMPANY_REGISTRATION = 'Company Registration',
    UPDATE_DIRECTORS = 'Directors',
    PHYSICAL_ADDRESS = 'Physical Address',
    COMPLETE_CARDS = 'Complete',
}
